// src/App.jsx

import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { GroupProvider } from './context/GroupContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import HomePage from './pages/HomePage';
import GroupSearchAndJoin from './pages/GroupSearchAndJoin';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import CreateGroup from './pages/admin/CreateGroup';
import AdminDashboard from './pages/admin/AdminDashboard';
import Login from './pages/Login';
import RegisterPage from './pages/RegisterPage';
import AdminRoute from './components/AdminRoute';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import ViewGroup from './pages/admin/ViewGroup';
import EditGroup from './pages/admin/EditGroup';
import AdminGroupsPage from './pages/admin/AdminGroupsPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminSupplierPage from './pages/admin/AdminSupplierPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PendingAdminApprovals from './pages/admin/PendingAdminApprovals';
// import LandingPage from './pages/LandingPage';
import InvitePage from './pages/InvitePage';
import JoinGroup from './pages/JoinGroup';
import AcceptInvite from './pages/Accept-invite';
import MyOrders from './pages/MyOrders';
import SupplierOrders from './pages/SupplierOrders';


function AppLayout({ children }) {
  const location = useLocation();

  // Only show Header if not on landing page "/"
  const showHeader = location.pathname !== '/';

  return (
    <div>
      {showHeader && <Header />}
      <main>{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <GroupProvider>
        <AppLayout>
          <Routes>
            {/* <Route path="/" element={<LandingPage />} /> */}
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/unauthorized" element={<div>You are not authorized to view this page.</div>} />
            <Route path="/admin" element={<AdminRoute allowedRoles={['superadmin']} ><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/suppliers" element={<AdminRoute allowedRoles={['superadmin']}><AdminSupplierPage /></AdminRoute>} />
            <Route path="/admin/supplier-orders" element={<AdminRoute allowedRoles={['supplieradmin']} ><SupplierOrders /></AdminRoute>} />
            <Route path="/admin/pending-admins" element={<AdminRoute allowedRoles={['superadmin']}><PendingAdminApprovals /></AdminRoute>} />
            <Route path="/admin/create-group" element={<AdminRoute allowedRoles={['supplieradmin']}><CreateGroup /></AdminRoute>} />
            <Route path="/admin/groups" element={<AdminRoute allowedRoles={['supplieradmin']}><AdminGroupsPage /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute allowedRoles={['supplieradmin']}><AdminUsersPage /></AdminRoute>} />
            <Route path="/admin/groups/view/:id" element={<AdminRoute allowedRoles={['supplieradmin']}><ViewGroup /></AdminRoute>} />
            <Route path="/admin/groups/edit/:id" element={<AdminRoute allowedRoles={['supplieradmin']}><EditGroup /></AdminRoute>} />


            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/join-group" element={<JoinGroup />} />
            <Route path="/Accept-invite" element={<AcceptInvite />} />

            <Route path="/GroupSearchAndJoin" element={<ProtectedRoute><GroupSearchAndJoin /></ProtectedRoute>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          </Routes>
        </AppLayout>

        {/* Global Toast Container - only one needed */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          theme="colored"

        />
      </GroupProvider>
    </BrowserRouter>
  );
}
